import { resolveCustomData } from '../../../../../utils/meta/resolveCustomData';
import type { MetaConversion } from '../../../../../utils/conversion/types';
import type { MetaTrackingConfig } from './types';

interface Args {
  config?: MetaTrackingConfig;
  values: Record<string, string>;
}

export function buildMetaConversion({
  config,
  values,
}: Args): MetaConversion | undefined {
  if (!config?.enabled || !config.eventName) return undefined;

  return {
    eventName: config.eventName,
    customData: resolveCustomData({ entries: config.customData, values }),
  };
}
